module.exports = __webpack_public_path__ + "static/2-4c2d10a1cc57e83e87dbca801685e184.jpg";